import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

const STATUS_COLORS = {
  pending: "bg-yellow-100 text-yellow-900 border-yellow-300",
  paid: "bg-green-100 text-green-900 border-green-300",
  failed: "bg-red-100 text-red-900 border-red-300",
  cancelled: "bg-zinc-100 text-zinc-700 border-zinc-300",
  refunded: "bg-blue-100 text-blue-900 border-blue-300",
};

export default function MyPayments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/payment-requests/mine").then((r) => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="my-payments">
      <div>
        <div className="overline text-zinc-500">Billing</div>
        <h1 className="font-display font-black text-3xl tracking-tight mt-1">My Payments</h1>
        <p className="text-xs text-zinc-500 mt-1">All your payment requests and invoices in one place.</p>
      </div>
      <div className="bg-white border border-zinc-200">
        {items.length === 0 ? (
          <div className="p-10 text-center text-sm text-zinc-500">
            No payment requests yet. <Link to="/membership" className="text-[#C8102E] underline">See plans</Link>.
          </div>
        ) : (
          <ul className="divide-y divide-zinc-200">
            {items.map((it) => (
              <li key={it.request_id} className="p-5 flex flex-wrap items-center gap-4" data-testid={`payment-row-${it.request_id}`}>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm">{it.plan_name || "Plan"}</div>
                  <div className="text-xs text-zinc-500 mt-0.5">{it.amount} · {new Date(it.created_at).toLocaleDateString()}</div>
                  {it.invoice_id && <div className="text-[10px] uppercase tracking-widest text-zinc-500 mt-1">Invoice: <span className="font-mono">{it.invoice_id}</span></div>}
                </div>
                <span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-1 border ${STATUS_COLORS[it.status] || STATUS_COLORS.pending}`}>{it.status}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
